export default __webpack_public_path__ + "static/media/binance-smart-chain.38b4b72a.jpg";